import { useSelector } from 'react-redux'
import { useQueryParams } from '@calendly/hooks'

import { isCookiesAllowedSelector } from 'selectors/gdpr'

export const useIsAnalyticsAllowed = () => {
  const { embed_type: embedType } = useQueryParams()
  const isPreview = embedType === 'preview'
  const isCookiesAllowed = useSelector(
    isCookiesAllowedSelector('targeting')
  )

  return isCookiesAllowed && !isPreview
}
